import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  LabelList,
  ResponsiveContainer
} from 'recharts'
import { CodeSnippet } from '..'
import { Col, Row } from 'react-styled-flexboxgrid'
import axios from 'axios'
import * as styles from './styles'
import variables from '../../styles/variables'


const CustomTooltip = (props) => {
  const { active, payload } = props
  if (active && payload) {
    const { label } = props
    const score = Math.round(_.first(payload).payload.$score * 100) / 100
    return (
      <styles.Tooltip>
        <h4>{label}</h4>
        <p>
          {label}
          &nbsp;has&nbsp;
          {score}
          &nbsp;times bigger probability to match your search.
        </p>
      </styles.Tooltip>
    )
  }
  return <div />
}

const propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  label: PropTypes.string
}

const defaultProps = {
  active: false,
  payload: [],
  label: ''
}
CustomTooltip.propTypes = propTypes
CustomTooltip.defaultProps = defaultProps

class HelsinkiCityBarChart extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: [],
      query: {},
      showQuery: false,
      search: ''
    }

    this.recommend = this.recommend.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.toggleQuery = this.toggleQuery.bind(this)
  }

  componentDidMount() {
    this.recommend()
  }

  toggleQuery() {
    this.setState(prevState => ({ showQuery: !prevState.showQuery }))
  }

  recommend(event) {
    if (event) event.preventDefault()

    const { search } = this.state

    const query = {
      select: ['$score', 'feature'],
      from: 'survey',
      where: {
        comment: search
      },
      get: 'location',
      orderBy: '$lift',
      limit: 5
    }

    this.setState({ query })

    axios.post(
      'https://aitoai-test-env.api.aito.ninja/api/v1/_query',
      query,
      {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': '3uqpLpTH3g2DA5xRRNFpH4wGAce2W5a29yiTtu7I'
        }
      }
    ).then(res => this.setState({ data: res.data.hits }))
  }

  handleChange(event) {
    this.setState({ search: event.target.value })
  }

  render() {
    const { data, showQuery, query } = this.state

    return (
      <styles.Container>
        <form onSubmit={this.recommend}>
          <styles.FormRow>
            <Col sm={8} xs={12}>
              <styles.SearchInput placeholder="Search" onChange={this.handleChange} />
            </Col>
            <styles.FormCol sm={2} xs={12}>
              <styles.SearchButton type="submit">Search</styles.SearchButton>
            </styles.FormCol>
          </styles.FormRow>
        </form>
        <Row>
          <Col xs={12}>
            <styles.LinkText onClick={this.toggleQuery}>
              {showQuery ? 'Hide Aito query' : 'See Aito query'}
            </styles.LinkText>
            <styles.Collapse active={showQuery}>
              <CodeSnippet language="javascript">
                {JSON.stringify(query, null, 2)}
              </CodeSnippet>
            </styles.Collapse>
          </Col>
        </Row>
        <styles.ChartRow>
          <ResponsiveContainer width="100%" height={400}>
            <BarChart
              width={500}
              height={300}
              data={data}
              layout="vertical"
              margin={{
                top: 5, right: 30, left: 20, bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" hide />
              <YAxis dataKey="feature" type="category" hide />
              <Tooltip content={<CustomTooltip />} />
              <Bar dataKey="$score" fill={variables.colors.jade.medium} minPointSize={100}>
                <LabelList
                  dataKey="feature"
                  position="insideEnd"
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </styles.ChartRow>

      </styles.Container>
    )
  }
}

export default HelsinkiCityBarChart
